import React, { memo, SVGProps } from 'react'

export const Italic = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.4429 6.02016H11.3865C10.9891 6.02016 10.6665 6.34272 10.6665 6.74016C10.6665 7.1376 10.9891 7.46016 11.3865 7.46016H12.8851L9.58078 16.5408H7.5571C7.15966 16.5408 6.8371 16.8634 6.8371 17.2608C6.8371 17.6582 7.15966 17.9808 7.5571 17.9808H12.6134C13.0109 17.9808 13.3334 17.6582 13.3334 17.2608C13.3334 16.8634 13.0109 16.5408 12.6134 16.5408H11.1149L14.4192 7.46016H16.4429C16.8403 7.46016 17.1629 7.1376 17.1629 6.74016C17.1629 6.34272 16.8403 6.02016 16.4429 6.02016Z"
      fill="currentColor"
    />
  </svg>
))
